// material-ui
import {useTheme} from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

// third-party
import {CSVLink} from 'react-csv';

// assets
import {Headers} from 'react-csv/lib/core';
import {DocumentDownload} from 'iconsax-react';
import {ReactElement} from 'react';

interface CSVExportProps {
    data: never[] | any[];
    filename: string;
    headers?: Headers;
    icon?: ReactElement;
    title?: string;
}

// ==============================|| CSV EXPORT ||============================== //

export const CSVExport: React.FC<CSVExportProps> = ({data, filename, headers, icon, title}) => {
    const theme = useTheme();

    return (
        <CSVLink data={data} filename={filename} headers={headers}>
            <Tooltip title={title ? title : 'CSV Export'}>
                {icon ? (
                    icon
                ) : (
                    <DocumentDownload
                        size={28}
                        variant="Outline"
                        style={{color: theme.palette.text.secondary, marginTop: 4, marginRight: 4, marginLeft: 4}}
                    />
                )}
            </Tooltip>
        </CSVLink>
    );
};

export default CSVExport;
